module.exports = __webpack_public_path__ + "static/media/css3_logo.7415a70a.svg";